import { render, staticRenderFns } from "./FilterSummaryOptionGourami.vue?vue&type=template&id=5ea77b02&"
import script from "./FilterSummaryOptionGourami.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionGourami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports